

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { EnumCustomerAddressTypes } from './../enums';
export class CustomerAddressesListParams extends BaseEntity
{   
    public Type: EnumCustomerAddressTypes; 
	
}



